import { useTranslation } from 'react-i18next'

export default function FormRequiredTip() {
  const { t } = useTranslation()

  return <div className="text-danger mb-8">{t('device:form_tip_field_required')}</div>
}
